import styled from '@emotion/styled';
import type { TextFieldProps } from '@mui/material';
import { InputLabel } from '@mui/material';
import { inputBaseClasses,
  inputClasses,
  inputLabelClasses,
  TextField } from '@mui/material';
import { isNotEmptyString } from '@weft/utils';
import React from 'react';
import { VyHint } from '../../new-design/data-display/VyHint';

const ForwardedTextField = React.forwardRef<
HTMLInputElement,
TextFieldProps & { hint?: string }
>(({ hint, ...props }, ref) => (
  <TextField
    ref={ref}
    autoComplete="off"
    {...props}
    variant="standard"
    InputProps={{
      disableUnderline: true,
      onWheel: (event) => {
        event.currentTarget.querySelector('input')?.blur();
      },
      ...props.InputProps,
    }}
    InputLabelProps={{
      shrink: true,
      component: (inputLabelProps) => {
        return (
          <div className="relative mb-4">
            <InputLabel {...inputLabelProps} />
            {isNotEmptyString(hint) && (
              <div className="absolute justify-end right-0 top-[-10px]">
                <VyHint title={hint}/>
              </div>
            )}
          </div>
        );
      },
      ...props.InputLabelProps,
    }}
    SelectProps={{
      MenuProps: {
        PaperProps: {
          sx: {
            marginTop: '8px',
            padding: 0,
            boxShadow: '0px 8px 16px 0px #0C124514',
            border: '1px solid #F0F4F6',
          },
        },
      },
    }}
  />
));

export const VayuTextField = styled(ForwardedTextField)({
  [`& .${inputBaseClasses.input}`]: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    background: 'transparent',
    alignItems: 'flex-end',
  },
  [`& .${inputClasses.root}`]: {
    transitionDuration: '0.2s',
    transitionTimingFunction: 'linear',
    '&.Mui-focused': {
      position: 'static',
      transitionDuration: '0.1s',
      transitionTimingFunction: 'linear',
      background: '#F6F9FA',
      padding: '8px 26px',
      borderRadius: '10px',
      '&.Mui-error': {
        border: '1px solid #FF154D',
      },
    },
  },
  [`& .${inputClasses.multiline}`]: {
    '&.Mui-focused': {
      padding: '12px 26px',
    },
  },
  [`& .${inputLabelClasses.root}`]: {
    fontSize: '18px',
  },
  [`& .${inputLabelClasses.shrink}`]: {
    transform: 'translate(0, -12px) scale(0.8)',
  },
  [`& .${inputLabelClasses.root}.Mui-error`]: {
    color: '#6D6D6D',
  },
  '& label.Mui-focused': {
    color: '#6D6D6D',
  },
  '& .MuiAutocomplete-endAdornment': {
    marginTop: '8px',
  },
});